import { Component } from '@angular/core';
import {NgxUiLoaderService} from 'ngx-ui-loader';
import {ActivatedRoute, Router} from '@angular/router';
import { QueryEnrollmentResponse, IdNowCommonResponse } from 'src/app/services/idnow-backend-services-domain';
import { IdnowBackendsService } from 'src/app/services/idnow-backend-services';
import { NotificationService } from 'src/app/services/notification.service';
import { truncate } from 'fs';
import { DeviceDetectorService } from 'ngx-device-detector';
import {UtilService} from "../../helpers/util.service";

@Component({
  selector: 'idnow-scan-rut',
  templateUrl: './scan-rut.component.html',
  styleUrls: ['./scan-rut.component.css']
})
export class ScanRutComponent {
  frontPicture: any;
  backPicture: any;
  enableButton: boolean;
  baseResponse: QueryEnrollmentResponse;
  base64Front: string;
  base64Back: string;
  dniResponse : IdNowCommonResponse;
  isSafari = false;
  isNotSafari = false;

  isDesktopDevice = false;
  takePic = false;
  uploadFile = false;
  showOptions = true;
  isiOS = false;

  deviceChecked = {
    isDesktop: false,
    isMobile: false,
    isTablet: false,
    so: ''
  };
  constructor(private ngxService: NgxUiLoaderService, private router: Router,
              private route: ActivatedRoute, private idnowBackendsService: IdnowBackendsService,
              private notifyService : NotificationService,  private deviceService: DeviceDetectorService,
              private utilService: UtilService) {
    this.enableButton = false;
    this.deviceChecked =  this.utilService.checkDevice();
    console.log('this.deviceChecked', this.deviceChecked);
    if (this.deviceChecked.so === 'iOS'){
      this.isiOS = true;
    }

    const ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') != -1) {
      if (ua.indexOf('chrome') > -1) {
        this.isNotSafari = true;
      } else {
        this.isSafari = true;
      }
    } else {
      this.isNotSafari = true;
    }
  }

  checkOption(option){
    console.log('option', option);
    this.showOptions =false;
    if (option==='cam'){
      this.takePic = true;
      this.uploadFile = false;
    }
    else {
      this.takePic = false;
      this.uploadFile = true;
    }
  }

  /*checkDevice() {

    this.deviceInfo = this.deviceService.getDeviceInfo();

    this.isMobile = this.deviceService.isMobile();

    this.isTablet = this.deviceService.isTablet();
    this.isDesktopDevice = this.deviceService.isDesktop();

    if (this.deviceInfo.os === 'iOS'){
        this.isiOS = true;
    }

  }*/
  takePictureFront($event: any) {
    this.frontPicture = $event.url ? $event.url : $event;
    this.enableButton = this.frontPicture && this.backPicture;
  }

  takePictureBack($event: any) {
    this.backPicture = $event.url ? $event.url : $event;
    this.enableButton = this.frontPicture && this.backPicture;
  }

  sendID() {
    try {
      this.ngxService.start();

      this.idnowBackendsService.analizeDni(this.frontPicture, this.backPicture,
          () => this.router.navigate(['/frontFace']));
    } catch (error) {
      console.error('Error en el componente: ', error);
      this.notifyService.showError(error, "Error")
    }
  }
}
